var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#44536D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 10.1035V17.5H10.8682V10.1035H12.8438ZM10.7451 8.17578C10.7451 7.88867 10.8454 7.65169 11.0459 7.46484C11.2464 7.27799 11.5153 7.18457 11.8525 7.18457C12.1852 7.18457 12.4518 7.27799 12.6523 7.46484C12.8574 7.65169 12.96 7.88867 12.96 8.17578C12.96 8.46289 12.8574 8.69987 12.6523 8.88672C12.4518 9.07357 12.1852 9.16699 11.8525 9.16699C11.5153 9.16699 11.2464 9.07357 11.0459 8.88672C10.8454 8.69987 10.7451 8.46289 10.7451 8.17578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.4cb2c10367828a1217c9e4c6d5b595c0.svg";
export { ForwardRef as ReactComponent };